/**
 * PX -> EM mapping
 *
 * Common breakpoints copied from tailwind @see {@link https://tailwindcss.com/docs/responsive-design}
 * For advantages of EMs for media queries @see {@link https://zellwk.com/blog/media-query-units/}
 */
export const pxToEm = {
  320: "20em",
  390: "24em",
  480: "30em",
  640: "40em",
  768: "48em",
  1024: "64em",
  1280: "80em",
  1536: "96em",
} as const;

export const deviceWidth = {
  mobileXs: pxToEm[320],
  mobileSm: pxToEm[390],
  mobileLg: pxToEm[480],
  tabletSm: pxToEm[640],
  tablet: pxToEm[768],
  laptop: pxToEm[1024],
  laptopLg: pxToEm[1280],
  desktop: pxToEm[1536],
};

export const breakpoints = {
  mobileXs: `@media (min-width: ${deviceWidth.mobileXs})`,
  mobileSm: `@media (min-width: ${deviceWidth.mobileSm})`,
  mobileLg: `@media (min-width: ${deviceWidth.mobileLg})`,
  tabletSm: `@media (min-width: ${deviceWidth.tabletSm})`,
  tablet: `@media (min-width: ${deviceWidth.tablet})`,
  laptop: `@media (min-width: ${deviceWidth.laptop})`,
  laptopLg: `@media (min-width: ${deviceWidth.laptopLg})`,
  desktop: `@media (min-width: ${deviceWidth.desktop})`,
};

export type PxToEm = typeof pxToEm;

export type BreakpointPxs = keyof PxToEm;

export type BreakpointEms = PxToEm[keyof PxToEm];
